type SmsProtocolHandler = (url: string) => void;

const handlers = new Set<SmsProtocolHandler>();
const bufferedUrls: string[] = [];
let electronSubscribed = false;
let draining = false;

function hasHandlers(): boolean {
  return handlers.size > 0;
}

function deliverToHandlers(url: string): void {
  if (!url) return;
  handlers.forEach((fn) => fn(url));
}

function bufferUrl(url: string): void {
  if (!url) return;
  bufferedUrls.push(url);
  console.log("[sms-protocol] buffering url until handler is ready");
}

function deliver(url: string): void {
  if (!url) return;
  if (hasHandlers()) {
    deliverToHandlers(url);
  } else {
    bufferUrl(url);
  }
}

function subscribeOnce(): void {
  if (electronSubscribed) return;

  const api = window.electronAPI;
  if (!api?.onSmsProtocol) return;
  electronSubscribed = true;
  api.onSmsProtocol((url) => {
    deliver(url);
  });
}

async function drainPending(): Promise<void> {
  if (draining) return;
  draining = true;
  try {
    const api = window.electronAPI;
    if (!api?.getPendingSmsUrls) return;

    const urls = await api.getPendingSmsUrls();
    for (const url of urls) {
      deliver(url);
    }
  } catch {
    console.log("[sms-protocol] failed to drain pending urls");
  } finally {
    draining = false;
  }
}

function flushBufferedTo(fn: SmsProtocolHandler): void {
  if (bufferedUrls.length === 0) return;
  const urls = bufferedUrls.splice(0);
  for (const url of urls) {
    fn(url);
  }
}

export function registerSmsProtocolHandler(fn: SmsProtocolHandler): () => void {
  subscribeOnce();
  handlers.add(fn);
  flushBufferedTo(fn);
  void drainPending();
  return () => {
    handlers.delete(fn);
  };
}
